export enum SelectedTimeframe {
  '1M' = '1M',
  '1J' = '1J',
  '3J' = '3J',
  '5J' = '5J',
  '10J' = '10J',
  'Aufl.' = 'Aufl.',
  'YTD' = 'YTD',
}
